// extracted by mini-css-extract-plugin
module.exports = {"offerDetails":"pulseofferdetails_offerDetails__dXG8c"};